$(document).ready(function(){

  var p_vir = $(document).getUrlParam("p_vir");
  var p_prc = $(document).getUrlParam("p_prc");
  var p_obj = $(document).getUrlParam("p_obj");

  if( typeof avast.mkt.hashDecoder !== 'undefined'){
    if (p_vir != null){
      $(".p_vir").text(beforeUrlText( avast.mkt.hashDecoder.decode(p_vir,'avast64') ));
    }
    if (p_obj != null){
      $(".p_obj").text(beforeUrlText( avast.mkt.hashDecoder.decode(p_obj,'avast64',true) ));
    }
  }



    /*
    if (p_prc != null){
      $(".p_prc").text(beforeUrlText(p_prc));
    }
    */

  $("table.lineone td").each(function(e){
    var text_lineone = $(this).text();
    var text_lineone_length = text_lineone.length;
    $(this).attr("title",text_lineone);
    //console.log( text_lineone.length );
    if (text_lineone_length > 52){
      $(this).text(text_lineone.substring(0,52) + "...");
    }
  });

	if( typeof avast.mkt.chromebox != 'undefined'){
		avast.mkt.chromebox.handle();
	}

  if( typeof avast.core !== 'undefined' ){
		if($("#features").length > 0){
			avast.core.normalizeStyle('.feat', 'height');
		}
  }

	if( $('.tintembed').length > 0 ){
		var tintupToHTML = '<div class="tintup-holder" style="-webkit-overflow-scrolling:touch;overflow:auto;position:relative;height:730px;width:960px;"><iframe class="tintup" src="http://www.tintup.com/avast?embed=true&height=700&width=960&cols=3" style="height:700px;width:960px;border:none;"></iframe><a href="http://www.tintup.com/blog/the-best-twitter-widget" style="width:118px; height:31px; background-image:url(https://s3-us-west-1.amazonaws.com/hypes-images/assets/logos/poweredbytintsmall.png); position:absolute; bottom:30px; right: 10px; text-indent: -9999px; z-index:9;">twitter widget</a></div>';
		$(".tintembed").html(tintupToHTML);
		$.getScript("https://s3-us-west-1.amazonaws.com/hypes-images/assets/scripts/tintembed.js");
	}

});

function beforeUrlText(path){
  if (path != null){
    path = path.replace(/%20/gi, " ");
    return path;
  }
  else
    return '';
}